import React from "react";
import { useTranslation } from "react-i18next";
import InputTextControl from "~/components/InputTextControl";
import Grid from "~/components-shared/Grid";
import { AIGenerateTargetEnum, ImageCategoryEnum } from "~/types/enums";
import AiGenerateButton from "~/components/AiGenerateButton";
import styled from "styled-components";
import InputTextAreaControl from "~/components/InputTextAreaControl";
import ImageUploadControl from "~/components/ImageUploadControl/ImageUploadControl";
const StyledAiButton = styled(AiGenerateButton)`
  position: absolute;
  bottom: 1.2rem;
  right: 1rem;
`;
const CompanyForm = _ref => {
  let {
    control,
    company,
    watch,
    setValue,
    setError
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    template: "1fr 170px",
    gap: 5
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(InputTextControl, {
    name: "name",
    label: t("CompanyForm.name"),
    s: {
      mb: 3
    },
    control: control,
    required: true
  }), /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    gap: 5,
    equal: true
  }, /*#__PURE__*/React.createElement(InputTextControl, {
    name: "url",
    label: t("CompanyForm.url"),
    s: {
      mb: 3
    },
    control: control,
    required: true
  }), /*#__PURE__*/React.createElement(InputTextControl, {
    name: "employeeCount",
    label: t("CompanyForm.employeeCount"),
    s: {
      mb: 3
    },
    control: control,
    type: "number",
    required: true
  })), /*#__PURE__*/React.createElement(InputTextControl, {
    name: "emailDomains",
    label: t("CompanyForm.emailDomains"),
    control: control,
    s: {
      mb: 3
    },
    required: true
  })), /*#__PURE__*/React.createElement(ImageUploadControl, {
    name: "logo",
    initPreview: company?.logo,
    control: control,
    label: t("CompanyUpdate.uploadLogo"),
    s: {
      mt: 8
    },
    category: ImageCategoryEnum.COMPANY,
    border: "rounded",
    width: "170px",
    height: "170px"
  })), /*#__PURE__*/React.createElement(InputTextAreaControl, {
    name: "description",
    label: t("CompanyForm.description"),
    control: control
  }, /*#__PURE__*/React.createElement(StyledAiButton, {
    target: AIGenerateTargetEnum.COMPANY_DESCRIPTION,
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("CompanyForm.generateDescription"),
    value: watch("url"),
    onGenerateStarted: () => setError("description", {}),
    onGenerateSucceeded: text => setValue("description", text),
    onGenerateFailed: message => setError("description", {
      type: "custom",
      message
    })
  })));
};
export default CompanyForm;